import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.fabricDataflowLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.FabricDataflowLabel),
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.FabricDataflowLabel)
    ]
})
export class FabricDataflowLinkedService extends LinkedService { }
